
var init = require('./init');

module.exports = init([require('./modules/attributes'), require('./modules/style')]);